/*
Monotype Foundry Platform API
Version 1.0.0

Definition: UserProfile

Properties:
  auth0Id: string
  displayName: string (required)
  email: string
  emailVerified: boolean
  gracePeriodExpired: boolean
  gracePeriodExpiresAt: string
  applicationStatus: string
  locationIso: string (required), maxLength: 2
  notificationSettings: object
  notifications: object
*/

var UserProfile = (function () {
  function validateUserProfile (arg) {
    // Validate auth0Id
    if (arg.auth0Id && !(typeof arg.auth0Id === 'string')) {
      throw new Error('UserProfile.auth0Id: Wrong type: Got \'' + (typeof arg.auth0Id) + '\', but expected: \'string\'')
    }
    // Validate displayName
    if (!arg.displayName) {
      throw new Error('UserProfile.displayName: Missing property')
    }
    if (arg.displayName && !(typeof arg.displayName === 'string')) {
      throw new Error('UserProfile.displayName: Wrong type: Got \'' + (typeof arg.displayName) + '\', but expected: \'string\'')
    }
    // Validate emailVerified
    if (arg.emailVerified && !(typeof arg.emailVerified === 'boolean')) {
      throw new Error('UserProfile.emailVerified: Wrong type: Got \'' + (typeof arg.emailVerified) + '\', but expected: \'boolean\'')
    }
    // Validate gracePeriodExpired
    if (arg.gracePeriodExpired && !(typeof arg.gracePeriodExpired === 'boolean')) {
      throw new Error('UserProfile.gracePeriodExpired: Wrong type: Got \'' + (typeof arg.gracePeriodExpired) + '\', but expected: \'boolean\'')
    }
    // Validate gracePeriodExpiresAt
    if (arg.gracePeriodExpiresAt && !(typeof arg.gracePeriodExpiresAt === 'string')) {
      throw new Error('UserProfile.gracePeriodExpiresAt: Wrong type: Got \'' + (typeof arg.gracePeriodExpiresAt) + '\', but expected: \'string\'')
    }
    // Validate applicationStatus
    if (arg.applicationStatus && !(typeof arg.applicationStatus === 'string')) {
      throw new Error('UserProfile.applicationStatus: Wrong type: Got \'' + (typeof arg.applicationStatus) + '\', but expected: \'string\'')
    }
    // Validate locationIso
    if (!arg.locationIso) {
      throw new Error('UserProfile.locationIso: Missing property')
    }
    if (arg.locationIso && !(typeof arg.locationIso === 'string')) {
      throw new Error('UserProfile.locationIso: Wrong type: Got \'' + (typeof arg.locationIso) + '\', but expected: \'string\'')
    }
    if (arg.locationIso && !(arg.locationIso.length <= 2)) {
      throw new Error('UserProfile.locationIso: Maximum length 2, but got: ' + arg.locationIso.length)
    }
    // Validate notificationSettings
    if (arg.notificationSettings && !(typeof arg.notificationSettings === 'object')) {
      throw new Error('UserProfile.notificationSettings: Wrong type: Got \'' + (typeof arg.notificationSettings) + '\', but expected: \'object\'')
    }
    // Validate notifications
    if (arg.notifications && !(typeof arg.notifications === 'object')) {
      throw new Error('UserProfile.notifications: Wrong type: Got \'' + (typeof arg.notifications) + '\', but expected: \'object\'')
    }
  }
  function buildUserProfile (arg) {
    var UserProfile = arg
    // Complete auth0Id
    // Expected Type: string
    UserProfile.auth0Id = UserProfile.auth0Id || ''
    // Complete displayName
    // Expected Type: string
    UserProfile.displayName = UserProfile.displayName || ''
    // Complete emailVerified
    // Expected Type: boolean
    UserProfile.emailVerified = UserProfile.emailVerified || false
    // Complete gracePeriodExpired
    // Expected Type: boolean
    UserProfile.gracePeriodExpired = UserProfile.gracePeriodExpired || false
    // Complete gracePeriodExpiresAt
    // Expected Type: string
    UserProfile.gracePeriodExpiresAt = UserProfile.gracePeriodExpiresAt || ''
    // Complete applicationStatus
    // Expected Type: string
    UserProfile.applicationStatus = UserProfile.applicationStatus || ''
    // Complete locationIso
    // Expected Type: string
    UserProfile.locationIso = UserProfile.locationIso || ''
    // Complete notificationSettings
    // Expected Type: object
    UserProfile.notificationSettings = UserProfile.notificationSettings || {}
    // Complete notificationSettings.submissionUpdate
    // Expected Type: boolean
    UserProfile.notificationSettings.submissionUpdate = UserProfile.notificationSettings.submissionUpdate || false
    // Complete notifications
    // Expected Type: object
    UserProfile.notifications = UserProfile.notifications || {}
    // Complete notifications.byEmail
    // Expected Type: boolean
    UserProfile.notifications.byEmail = UserProfile.notifications.byEmail || false
    return UserProfile
  }
  return {
    validate: validateUserProfile,
    build: buildUserProfile
  }
})()

module.exports = UserProfile
